import {
  CssCustomProperties,
  CssProperties,
  EditorReactComponent,
} from '@wix/component-protocol/schema';
import { CompRef } from '@wix/document-services-types';
import { StylesDerivedNativeActionNames } from '@wix/editor-platform-host-integration-apis';
import {
  ComponentsPlatformService,
  AbstractVirtualManifestBuilder,
} from '@wix/editor-platform-manifest-services';
import {
  EditorPointer,
  EditorPointerServiceAPI,
} from '@wix/editor-document-logic-api';

export type GlobalDesignActionValidator = (
  componentsAPI: ComponentsPlatformService,
  editorPointers: EditorPointer<CompRef>[],
) => boolean;

export type ManifestProcessor = (
  manifest: EditorReactComponent,
  actionName: StylesDerivedNativeActionNames,
  builder: AbstractVirtualManifestBuilder,
  editorPointer: EditorPointer<CompRef>,
  editorPointerAPI: EditorPointerServiceAPI,
) => void;

export type GlobalDesignAction = {
  validator: GlobalDesignActionValidator;
  manifestProcessor: ManifestProcessor;
};

export type Styles = {
  cssCustomProperties: CssCustomProperties;
  cssProperties: CssProperties;
};

export const STYLE_NAMESPACE = {
  CssCustomProperties: 'cssCustomProperties',
  CssProperties: 'cssProperties',
} as const;

export type StyleNamespace =
  (typeof STYLE_NAMESPACE)[keyof typeof STYLE_NAMESPACE];
